import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import Badge from '../../../components/atoms/Badge';
import Icon, { IconSizes, IconVariants } from '../../../components/foundations/Icon';
import { TRANSLATE_PREFIX } from '../../consts';
import DeleteIcon from '../DeleteIcon';
import css from './SingularMacroCell.css';

const TAB_PREFIX = `${TRANSLATE_PREFIX}.POSTBACK_TEMPLATES_TAB`;

const SingularMacroCell = ({ row, onRemove, readOnly, translate }) => (
    <td className={css.cell}>
        <div className={css.macroCell}>
            {!readOnly && (
                <DeleteIcon
                    className={css.deleteBtn}
                    confirmTitleKey={`${TAB_PREFIX}.CONFIRM_DIALOG.REMOVE_TEMPLATE_MACRO_TITLE`}
                    confirmTextKey={`${TAB_PREFIX}.CONFIRM_DIALOG.REMOVE_TEMPLATE_MACRO_TEXT`}
                    shouldConfirm={!!(row.partner_parameter_key || '').trim()}
                    onConfirm={() => onRemove(row.singular_macro)}
                />
            )}
            <div className={css.macroRow}>
                <code className={css.macroCode}>{row.singular_macro}</code>
                {row.isDefault && (
                    <Badge color={null} className={css.defaultTag}>
                        <Translate id={`${TAB_PREFIX}.DEFAULT_TAG`} />
                    </Badge>
                )}
            </div>
            {row.requiresTrackingLinkParam && !readOnly && (
                <div className={css.requiresTrackingLink}>
                    <Icon
                        name="info-triangle"
                        size={IconSizes.X_SMALL}
                        variant={IconVariants.WARNING}
                        interactive={false}
                    />
                    <span>{translate(`${TAB_PREFIX}.REQUIRES_TRACKING_LINK_PARAM`)}</span>
                </div>
            )}
        </div>
    </td>
);

SingularMacroCell.propTypes = {
    row: PropTypes.shape({
        singular_macro: PropTypes.string.isRequired,
        partner_parameter_key: PropTypes.string,
        isDefault: PropTypes.bool,
        requiresTrackingLinkParam: PropTypes.bool,
    }).isRequired,
    onRemove: PropTypes.func.isRequired,
    readOnly: PropTypes.bool,
    translate: PropTypes.func.isRequired,
};

export default SingularMacroCell;
